var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveTokenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 3.31976L50.7977 14.0283C52.4995 15.0108 53.5477 16.8265 53.5477 18.7915V40.2085C53.5477 42.1735 52.4995 43.9892 50.7977 44.9717L32.25 55.6802C30.5483 56.6627 28.4517 56.6627 26.75 55.6802L8.20225 44.9717C6.50055 43.9892 5.45225 42.1735 5.45225 40.2085V18.7915C5.45225 16.8265 6.50055 15.0108 8.20225 14.0283L26.75 3.31976C28.4517 2.33728 30.5483 2.33728 32.25 3.31976Z",
    stroke: "#1E8B7C",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4417 16.4651L39.6975 19.2093M29.2559 29.6509L34.8952 24.0116M34.8952 24.0116L39.0114 28.1279L43.8138 23.3256L39.6975 19.2093M34.8952 24.0116L39.6975 19.2093M29.2559 29.6509C29.9643 30.3499 30.5275 31.1822 30.913 32.0998C31.2985 33.0174 31.4987 34.0022 31.502 34.9974C31.5054 35.9927 31.3118 36.9788 30.9324 37.899C30.5531 38.8191 29.9955 39.6551 29.2917 40.3589C28.588 41.0627 27.7519 41.6203 26.8318 41.9996C25.9116 42.379 24.9255 42.5725 23.9303 42.5692C22.935 42.5659 21.9502 42.3657 21.0326 41.9802C20.115 41.5947 19.2828 41.0315 18.5837 40.323C17.2091 38.8998 16.4484 36.9935 16.4656 35.0148C16.4828 33.0361 17.2765 31.1434 18.6757 29.7442C20.0748 28.345 21.9676 27.5514 23.9463 27.5342C25.9249 27.517 27.8312 28.2776 29.2545 29.6523L29.2559 29.6509Z",
    stroke: "#1E8B7C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4625,
    cy: 44.4625,
    r: 11.4,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.75 29.5C36.8107 29.5 30.5 35.8107 30.5 43.75C30.5 51.6893 36.8107 58 44.75 58C52.6893 58 59 51.6893 59 43.75C59 35.8107 52.6893 29.5 44.75 29.5ZM50.2464 50.875L44.75 45.3786L39.2536 50.875L37.625 49.2464L43.1214 43.75L37.625 38.2536L39.2536 36.625L44.75 42.1214L50.2464 36.625L51.875 38.2536L46.3786 43.75L51.875 49.2464L50.2464 50.875Z",
    fill: "#1E8B7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveTokenIcon);
export default __webpack_public_path__ + "static/media/remove-token-icon.6ba3ad66.svg";
export { ForwardRef as ReactComponent };